import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, theme, Grid } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { FaHome, FaMoneyBillWave, FaCoffee, FaUsers, FaStore, FaWallet, FaPiggyBank, FaUserTie, FaCalendarAlt } from 'react-icons/fa';
import MenuTinChap from './tinchap/menu/MenuTinChap';
import MenuTraGop from './tragop/menu/MenuTraGop';
import Dashboard from './home/Dashboard';
import BadgeAnt from './untils/BadgeAnt';
import LandingPage from './home/LandingPage';
import AlertTinChap from './home/AlertTinChap';
import AlertTragop from './home/AlertTragop';
import logo from './../assets/logo.jpg'; // Nhập logo

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;

export default function MenuAnt({ chooseMenu }) {
    const [collapseState, setCollapseState] = useState('hidden');
    const [selectedMenu, setSelectedMenu] = useState(chooseMenu);
    const screens = useBreakpoint();

    useEffect(() => {
        if (!screens.md) {
            setCollapseState('hidden'); // Default to hidden on mobile
        } else {
            setCollapseState('hidden'); // Default to expanded on larger screens
        }
    }, [screens]);

    const handleMenuClick = (menu) => {
        setSelectedMenu(menu);
        // Ẩn sidebar nếu đang ở chế độ điện thoại
        if (!screens.md) {
            setCollapseState('hidden');
        }
    };

    const toggleCollapse = () => {
        setCollapseState((prevState) => {
            if (!screens.md) {
                return prevState === 'expanded' ? 'hidden' : 'expanded';
            } else {
                switch (prevState) {
                    case 'expanded':
                        return 'collapsed';
                    case 'collapsed':
                        return 'hidden';
                    case 'hidden':
                        return 'expanded';
                    default:
                        return 'expanded';
                }
            }
        });
    };

    const renderComponent = () => {
        switch (selectedMenu) {
            case 'tinchap':
                return <MenuTinChap />;
            case 'tragop':
                return <MenuTraGop />;
            case 'dashboard':
                return <Dashboard />;
            case 'AlertTinchap':
                return <AlertTinChap />;
            case 'AlertTragop':
                return <AlertTragop />;
            default:
                return <LandingPage />;
        }
    };

    const handleAlertSelection = (menu) => {
        setSelectedMenu(menu);
    };

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    return (
        <Layout>
            {collapseState !== 'hidden' && (
                <Sider
                    trigger={null}
                    collapsible
                    collapsed={collapseState === 'collapsed'}
                    width={240}
                    style={{ minHeight: '100vh' }}
                >
                    {/* Thêm logo ở đây */}
                    <div style={{ textAlign: 'center', padding: '16px' }}>
                        <img src={logo} alt="Logo" style={{ width: '100%', height: 'auto' }} />
                    </div>
                    
                    <Menu
                        theme="dark"
                        mode="inline"
                        defaultSelectedKeys={['1']}
                        selectedKeys={[selectedMenu]}
                        onClick={(e) => handleMenuClick(e.key)}
                        items={[
                            { key: 'dashboard', icon: <FaHome />, label: 'Trang chủ' },
                            { key: 'tinchap', icon: <FaMoneyBillWave />, label: 'Tín Chấp' },
                            { key: 'tragop', icon: <FaCoffee />, label: 'Trả góp' },
                            { key: 'khachhang', icon: <FaUsers />, label: 'Khách hàng' },
                            { key: 'cuahang', icon: <FaStore />, label: 'Quản lý cửa hàng' },
                            { key: 'thuchi', icon: <FaWallet />, label: 'Quản lý thu chi' },
                            { key: 'von', icon: <FaPiggyBank />, label: 'Quản lý nguồn vốn' },
                            { key: 'nhanvien', icon: <FaUserTie />, label: 'Quản lý nhân viên' },
                            { key: 'baocao', icon: <FaCalendarAlt />, label: 'Báo cáo' },
                        ]}
                    />
                </Sider>
            )}
            <Layout>
                <Header
                    style={{
                        padding: 0,
                        background: colorBgContainer,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Button
                        type="text"
                        icon={collapseState === 'hidden' ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                        onClick={toggleCollapse}
                        style={{ fontSize: '16px', width: 64, height: 64 }}
                    />
                    <div style={{ marginRight: '30px', marginTop: '15px' }}>
                        <BadgeAnt onMenuSelect={handleAlertSelection} />
                    </div>
                </Header>
                <Content
                    style={{
                        margin: '24px 10px',
                        padding: 0,
                        minHeight: 280,
                        background: colorBgContainer,
                        borderRadius: borderRadiusLG,
                    }}
                >
                    {renderComponent()}
                </Content>
            </Layout>
        </Layout>
    );
}